export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/dragging-icon.svg?01b80fe8718a374509a39e2116e31e8d";